import { render, staticRenderFns } from "./MoneyView.vue?vue&type=template&id=f609fa40&scoped=true&"
import script from "./MoneyView.vue?vue&type=script&lang=ts&"
export * from "./MoneyView.vue?vue&type=script&lang=ts&"
import style0 from "./MoneyView.vue?vue&type=style&index=0&id=f609fa40&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f609fa40",
  null
  
)

export default component.exports